import { useEffect, useState } from "react"
import ReactFlow, {MiniMap,  Controls, useStoreActions, isNode, isEdge } from 'react-flow-renderer';
import { uuid } from "../HelperFunctions";





export const useNodesClipboard = () => {

  //const [flow, setFlow] = useState(null);
  const [supportClipboardRead, setSupportClipboardRead] = useState(()=>navigator.clipboard && navigator.clipboard.readText);
  const [supportClipboardWrite, setSupportClipboardWrite] = useState(()=>navigator.clipboard && navigator.clipboard.writeText);

  /*
  useEffect(()=>{
    if(!supportClipboardRead) return;
    const timer = setInterval(()=>{
      flowFromClipboard()
        .then(result =>{
          if(!(flow && flow.id === result.id)){
            setFlow(getFlowWithParsedElements(result));
          }
        })
        .catch(reason=>{
          console.log(reason);
          if(flow) setFlow(null);
        });
    }, 1000)
    return ()=>clearInterval(timer);
  }, [flow])
*/

  const tryGetFlow = () => new Promise((resolve, reject) => {
    flowFromClipboard()
      .then(result =>{
        resolve(getFlowWithParsedElements(result));
      })
      .catch(reason=>{
        reject(reason)
      });
  });


  const getFlowWithParsedElements = (flow) => ({...flow, elements: JSON.parse(flow.elements)})

  const flowFromClipboard = () => new Promise((resolve, reject)=>{
    navigator.clipboard.readText()
      .then(text => {
        setSupportClipboardRead(true);
        flowFromText(text)
          .then(result=>{
            resolve(result);
          })
          .catch(e=>{
            reject(e);
          })
      })
      .catch(err => {
        setSupportClipboardRead(false);
        reject("no se pudo leer el clipboard");
      });
  })

  const flowFromText = (text) => new Promise((resolve, reject)=>{
    try{
      const result = JSON.parse(text);
      if(result.type==="flow" && result.elements && result.id){
        resolve(result);
      }else{
        reject("es un json pero no un flow");
      }
    }catch(e){
      reject("no es un json");
    }
  });

  const flowToClipboard = ({elements, flowName}) => {
    const toClipboard = JSON.stringify({
      type:"flow", 
      elements: JSON.stringify(elements),
      flowName,
      id: uuid()
    });

    if (!supportClipboardWrite) {
      fallbackCopyTextToClipboard(toClipboard);
      return;
    }

    navigator.clipboard.writeText(toClipboard)
      .catch((err) => {
        console.error('No se pudo escribir contenido en el clipboard: ', err);
      });   
  }

  const isStartNode = (item) => item.type === "NodeStart";

  const anyElementById = (id, list) => list.some(item => item.id === id);

  const isOrphan = (item, list) => !anyElementById(item.source, list) || !anyElementById(item.target, list);
  
  const pasteFlowIntoElements = ({elements = [], flow, resolveElement}) => {
    
    //console.log({elements, flow, resolveElement})

    const hasStartNode = flow.elements.some(element => isStartNode(element));
    const flowStartNode = hasStartNode && flow.elements.find(element => isStartNode(element));
    const elementsStartNode = hasStartNode && elements.find(element => isStartNode(element));

    //console.log({hasStartNode, flowStartNode, elementsStartNode})
    
    const flowWithoutOrphans = flow.elements.filter(element => {
      return isNode(element) || (isEdge(element) && !isOrphan(element, flow.elements))
    });
    
    
    const flowWithoutStart = flowWithoutOrphans.filter(element => !isStartNode(element));  

    //console.log({flowWithoutStart})

    const newIds = flowWithoutStart.map(element => ({
      id: element.id,
      newId: uuid()
    }));

    const flowWithNewIds = flowWithoutStart.map(element => {
      if (isNode(element)){
        return {
          ...element, 
          id: newIds.find(item => item.id === element.id).newId
        }
      }
      if (isEdge(element)){
        const newSource = (hasStartNode && flowStartNode.id === element.source)
          ? elementsStartNode.id
          : newIds.find(item => item.id === element.source).newId;
        const newTarget = newIds.find(item => item.id === element.target).newId;
        return {
          ...element, 
          id: `e${newSource}-${newTarget}`, 
          source: newSource, 
          target: newTarget
        }        
      }
    });

    //console.log({flowWithNewIds})

    const maxY = elements.map(e => isNode(e) ? e.position.y : Number.MIN_SAFE_INTEGER).sort((a, b) => b - a)[0];
    const minX = elements.map(e => isNode(e) ? e.position.x : Number.MAX_SAFE_INTEGER).sort((a, b) => a - b)[0];
    
    const minFlowX = flowWithNewIds.map(e => isNode(e) ? e.position.x : Number.MAX_SAFE_INTEGER).sort((a, b) => a - b)[0];
    const minFlowY = flowWithNewIds.map(e => isNode(e) ? e.position.y : Number.MAX_SAFE_INTEGER).sort((a, b) => a - b)[0];
    
    const flowWithNewPositions = flowWithNewIds.map(element => {
      return isNode(element) ? {...element, position: {x: minX + (element.position.x + 100 - minFlowX), y: maxY + (element.position.y + 100 - minFlowY) }} : element
    })

    //console.log({flowWithNewPositions})

    const resolveFlow = flowWithNewPositions.map(el => resolveElement(el));

    //console.log({resolveFlow})

    return [...resolveFlow, ...elements];

  }

  const fallbackCopyTextToClipboard = (text) => {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      //console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textArea);
  }

  const replaceValues = (flow, replaces) => {
    return JSON.parse(replaces.reduce((prev, curr) => {
      return prev.replace(curr.searchValue(flow), curr.replaceValue);
    }, JSON.stringify(flow)));
  }

  const getFlow = ({replaces = null} = {}) => new Promise((resolve, reject)=>{
    const resolver = replaces 
          ? (flow) => resolve(replaceValues(flow, replaces))
          : (flow) => resolve(flow);

    if(supportClipboardRead) {
      tryGetFlow()
        .then(flow => {
          resolver(flow);
        })
        .catch(reason => {
          reject(reason);
        });
    }else{
      const codeFlow = window.prompt("El explorador no soporta el clipboard, porque estás en un sitio no seguro. Pegá aca el código del flujo que copiaste.", "");
      if(codeFlow){
        flowFromText(codeFlow)
          .then(result => {
            resolver(getFlowWithParsedElements(result));
          })
          .catch(e => reject(e))
      }else{
        reject();
      }
    }
  })

  return {flowToClipboard, flowFromText, supportClipboardRead, getFlowWithParsedElements, pasteFlowIntoElements, getFlow};

}
